import React, { useRef } from "react";
import classNames from "classnames";
import ClipLoader from "react-spinners/ClipLoader";
import { FaCaretDown } from "react-icons/fa";
import "./style.scss";

interface Props {
  values?: {
    title: string;
    id: any;
  }[];
  label?: string;
  className?: string;
  placeholder?: string;
  isLoading?: boolean;
  disabled?: boolean;
  value?: string;
  onChange?(param: string): void;
  width?: number;
}

export const Select2: React.FC<Props> = ({
  className,
  values = [],
  isLoading = false,
  disabled = false,
  value = "",
  onChange = () => {},
  width,
}) => {
  const actionRef = useRef<HTMLDivElement>(null);

  const handleChange = (param: any) => {
    actionRef.current && actionRef.current.blur();
    onChange(param);
  };

  return (
    <div
      className={classNames("select-control2", className)}
      style={{ width: width || "auto" }}
    >
      <div
        className="select-control2__container"
        ref={actionRef}
        tabIndex={disabled ? undefined : 0}
      >
        <div
          className={classNames("select-control2__main", {
            active: value,
          })}
        >
          <div className="flex-1 d-flex justify-content-between overflow-hidden">
            <span className="my-auto text-ellipsis">
              {values.find((item) => item.id === value)?.title}
            </span>
          </div>
          <FaCaretDown className="select-control2__arrow" />
        </div>
        <div className={classNames("select-control2__menu")}>
          {isLoading ? (
            <ClipLoader
              size={40}
              color="#297D4A"
              cssOverride={{
                display: "block",
                margin: "20px auto",
              }}
            />
          ) : values.length > 0 ? (
            values.map(({ title, id: itemVal }) => {
              return (
                <div
                  className={classNames("select-control2__menu-item", {
                    active: value === itemVal,
                  })}
                  key={itemVal}
                  onClick={() => handleChange(itemVal)}
                >
                  <span>{title}</span>
                </div>
              );
            })
          ) : (
            <div className="my-3 text-gray text-center">Empty</div>
          )}
        </div>
      </div>
    </div>
  );
};
